import { render, staticRenderFns } from "./applist.vue?vue&type=template&id=a1964d94&scoped=true&"
import script from "./applist.vue?vue&type=script&lang=js&"
export * from "./applist.vue?vue&type=script&lang=js&"
import style0 from "./applist.vue?vue&type=style&index=0&id=a1964d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1964d94",
  null
  
)

export default component.exports